"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Card = _interopRequireDefault(require("../../Card"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CheckedIcon = function CheckedIcon(_ref) {
  var color = _ref.color;
  return _react["default"].createElement(_Card["default"], {
    borderRadius: 9999,
    border: "2px solid",
    borderColor: "".concat(color, ".500"),
    width: 22,
    height: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, _react["default"].createElement(_Card["default"], {
    borderRadius: 9999,
    bg: "".concat(color, ".500"),
    width: 12,
    height: 12
  }));
};

CheckedIcon.defaultProps = {
  color: 'teal',
  theme: _theme["default"]
};

var _default = (0, _styledComponents.withTheme)(CheckedIcon);

exports["default"] = _default;